import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { fetchAvailableTags } from '@/entities/tags/api';

export const useAvailableTags = () => {
  return useQueryWithBoundary({
    queryKey: tagKeys.availableTags(),
    queryFn: fetchAvailableTags,
    staleTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
